<template>
  <b-card>
    <div slot="header">افزودن محتوای شرکت کننده</div>
    <b-row>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.attachment_type"
          label-for="attachment_type"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.attachment_type"
            :rules="$v.attachment_type_selected.$params"
          />
          <selectFind
            :options="attachmentTypeOptions"
            v-model="$v.attachment_type_selected.$model"
            label="caption"
            id="id"
            :isValid="
              $v.attachment_type_selected.$dirty
                ? !$v.attachment_type_selected.$error
                : null
            "
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.attachment_type_selected.$error ? 'block' : 'none',
            }"
            id="attachment_type_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.attachment_type) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.caption"
          label-for="caption"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.caption"
            :rules="$v.caption.$params"
          />
          <b-form-input
            id="caption"
            type="text"
            autocomplete="off"
            v-model="$v.caption.$model"
            :state="$v.caption.$dirty ? !$v.caption.$error : null"
          >
          </b-form-input>
          <b-form-invalid-feedback id="caption-feedback"
            >{{ $lang.error_required | replace($lang.caption) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <ShowCardUpload
      :url="attachmentUrl"
      :hasAppendData="true"
      acceptFormatsInput=""
      :acceptFormats="acceptFormats"
      :appendData="appendData"
      :isValidAppendData="isValidAppendData"
      :parentLoading="loading"
      :uploadByCallback="true"
      @submit="submit"
      @closeModal="closeModal"
      @getItems="getItems"
    />
  </b-card>
</template>

<script>
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  components: { ShowCardUpload },
  validations: {
    attachment_type_selected: { required },
    caption: { required },
  },
  props: {
    caseId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      attachment_type_selected: null,
      caption: null,
      attachmentTypeName: "attachment_type_center_execute",
      attachmentTypeId: 46,
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      attachmentUrl: null,
    };
  },
  computed: {
    attachmentTypeOptions() {
      return renderEumOptions(this.attachmentTypeName).map((item) => {
        return {
          id: pathOr(null, ["value"], item),
          caption: pathOr(null, ["text"], item),
        };
      });
    },
    appendData() {
      const name = pathOr("", ["caption"], this.attachment_type_selected);
      return {
        caption: `${name} - ${this.caption}`,
        attachment_type_id: this.attachmentTypeId,
        attachment_type_name: this.attachmentTypeName,
      };
    },
    isValidAppendData() {
      return !!(this.attachment_type_selected && this.caption);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    renderEumOptions,
    closeModal() {
      this.$emit("closeModal");
    },
    getItems() {
      this.$emit("getItems");
    },
    async submit(callback) {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.loading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_person_content"],
          [this.caseId]
        );
        const payload = {
          name: pathOr("", ["caption"], this.attachment_type_selected),
          description: this.caption,
          reference: {
            resource: "center_execute_case",
            key: this.caseId,
          },
        };
        const response = await this.$httpService.post(url, payload);
        const id = pathOr(null, ["data", "data"], response);
        this.attachmentUrl = generateApiUrl(
          ["resources", "attachment"],
          ["person_content", id]
        );
        setTimeout(() => callback(), 500);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
